import { useTheme } from '@mui/material';
import { useConfig } from '../../../Hooks/useConfig';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import ActivateTrialModal from '../../../pages/PricingPage/components/ActivateTrialModal';
import AIButton from '../../Button/AIButton';
import PropTypes from 'prop-types';

const UpgradePlanButton = ({
  extrnalLink = false,
  showIcon = true,
  sx = {},
  userInfo = '',
  isCollapsed = false,
  enableSunset = false,
  forceTryForFree = false,
  variant,
}) => {
  const { panelUrl } = useConfig();
  const { t } = useTranslation();
  const theme = useTheme();
  const [isTrialModalOpen, setIsTrialModalOpen] = useState(false);

  const getPlanName = (planName) => {
    if (planName === 'free' && !userInfo.trial_used) {
      return enableSunset && !forceTryForFree
        ? 'Activate Trial'
        : t('upgrade_box.try_for_free');
    } else if (userInfo?.payment?.plan_type?.includes('TRIAL')) {
      // For all trial plans, always show "Upgrade to Pro"
      return t('upgrade_box.upgrade_pro');
    } else if (!planName) {
      return t('upgrade_box.upgrade_basic');
    } else if (planName.toLowerCase().includes('basic')) {
      return t('upgrade_box.upgrade_pro');
    } else {
      return t('upgrade_box.upgrade_basic');
    }
  };

  const handleButtonClick = (e) => {
    if (userInfo?.payment?.plan_name === 'free' && !userInfo.trial_used) {
      e.preventDefault();
      setIsTrialModalOpen(true);
    }
  };

  const handleCloseTrialModal = () => {
    setIsTrialModalOpen(false);
  };
  if (variant === 'CustomPlan') {
    return (
      <AIButton link to="/billing/pricing" width="full" sx={sx} theme="sky">
        Custom Plan
      </AIButton>
    );
  }

  return (
    <>
      {userInfo &&
      !userInfo?.payment?.plan_name.toLowerCase().includes('pro') ? (
        <AIButton
          link={!extrnalLink}
          to={!extrnalLink ? '/billing/pricing' : ''}
          href={extrnalLink ? `${panelUrl}/billing/pricing` : ''}
          onClick={handleButtonClick}
          width={isCollapsed ? 'auto' : 'full'}
          sx={{
            fontSize: {
              xs: `${theme.spacing(4)} !important`,
              md: `${theme.spacing(3)} !important`,
              lg: `${theme.spacing(3.5)} !important`,
              xl: `${theme.spacing(4)} !important`,
            },
            padding: isCollapsed ? theme.spacing(3, 0) : theme.spacing(3, 4),
            minWidth: isCollapsed ? '40px' : undefined,
            marginLeft: isCollapsed ? theme.spacing(2) : 0,
            [theme.breakpoints.up('xl')]: {
              padding: isCollapsed ? theme.spacing(3, 0) : theme.spacing(3, 4),
            },
            [theme.breakpoints.down('md')]: {
              padding: theme.spacing(2, 2),
            },
            [theme.breakpoints.down('420')]: {
              padding: theme.spacing(1.5, 2),
            },
            ...sx,
          }}
          theme={
            enableSunset &&
            userInfo?.payment?.plan_name === 'free' &&
            !userInfo?.trial_used
              ? 'sunset'
              : userInfo?.payment?.plan_name?.toLowerCase().includes('free')
                ? 'sky'
                : 'ocean'
          }
        >
          {!isCollapsed && showIcon
            ? getPlanName(userInfo?.payment?.plan_name)
            : null}
        </AIButton>
      ) : null}

      <ActivateTrialModal
        open={isTrialModalOpen}
        handleClose={handleCloseTrialModal}
        planName={userInfo?.payment?.plan_name}
      />
    </>
  );
};

UpgradePlanButton.propTypes = {
  extrnalLink: PropTypes.bool,
  showIcon: PropTypes.bool,
  sx: PropTypes.object,
  userInfo: PropTypes.any,
  isCollapsed: PropTypes.bool,
  enableSunset: PropTypes.bool,
  forceTryForFree: PropTypes.bool,
  variant: PropTypes.string,
};

export default UpgradePlanButton;
